"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerSocialsService = void 0;
class ManagerSocialsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Remove manager social media
     * @param managerSocialMediaId manager social media relation uuid
     * @param id manager uuid
     * @returns DeleteResponse
     * @throws ApiError
     */
    removeManagerSocialMedia(managerSocialMediaId, id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/managers/{id}/socials/{managerSocialMediaId}',
            path: {
                'managerSocialMediaId': managerSocialMediaId,
                'id': id,
            },
        });
    }
    /**
     * Add manager social media
     * @param id manager uuid
     * @param requestBody
     * @returns CreateManagerSocialResponse
     * @throws ApiError
     */
    addManagerSocialMedia(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/managers/{id}/socials/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.ManagerSocialsService = ManagerSocialsService;
